export default function FilterCareer() {

    if ($('.v-career__jobs').length > 0) {

        const $filter = {
            btn: $('.v-faq__filter button'),
            item: $('.v-career__item'),
            data: 'career-filter'
        }

        $filter.btn.click(function () {
            const $value = $(this).data($filter.data);
            const $value_result = ($value !== '') ? '.' + $(this).data($filter.data) : '';

            if (!$(this).hasClass('js-isActive')) {
                $(this).addClass('js-isActive');
            }

            $filter.item.hide(0);
            $('.v-career__item' + $value_result).show(0);

        });
    }
}
